import { token, whoami } from './auth';
import {
  inprogressDocs as iteInprogressDocs,
  whoami as iteWhoami,
} from './ite';
import { inprogressDocs } from './docs';

export const INIT_REQUEST = 'Init.Request';
export const INIT_SUCCESS = 'Init.Success';

export default function initialize() {
  return (dispatch) => Promise.resolve()
    .then(() => dispatch({ type: INIT_REQUEST }))
    .then(() => {
      const prefix = location.pathname.substring(0, 5);
      if (prefix === '/ite/' || prefix === '/sys/') {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        return dispatch(iteWhoami(token))
          .then(() => dispatch(iteInprogressDocs(token)));
      }
      return dispatch(token())
        .then(() => dispatch(whoami()))
        .then(() => dispatch(inprogressDocs()));
    })
    .then(() => dispatch({ type: INIT_SUCCESS }));
}
